import {
  MAX_FILE_SIZE,
  MAX_FILES_AMOUNT,
  MAX_FILES_SIZE,
} from "../../const/enviroment.ts";

export const ERROR = {
  CATEGORIES_NOT_FOUND: "CATEGORIES_NOT_FOUND",
  CATEGORY_INVALID: "CATEGORY_INVALID",
  CATEGORY_NOT_FOUND: "CATEGORY_NOT_FOUND",
  CHAT_INVALID: "CHAT_INVALID",
  DATAPROTECTION_NOT_READ: "DATAPROTECTION_NOT_READ",
  FETCH: "FETCH",
  FILE_AMOUNT_LIMIT: "FILE_AMOUNT_LIMIT",
  FILE_DELETE: "FILE_DELETE",
  FILE_SIZE_LIMIT: "FILE_SIZE_LIMIT",
  FILE_UPLOAD: "FILE_UPLOAD",
  ITEM_INVALID: "ITEM_INVALID",
  ITEM_NOT_FOUND: "ITEM_NOT_FOUND",
  LOGIN_INVALID: "LOGIN_INVALID",
  NETWORK: "NETWORK",
  OTP_EXPIRED: "OTP_EXPIRED",
  PAYLOAD_MALFORMATTED: "PAYLOAD_MALFORMATTED",
  REGISTER_INVALID: "REGISTER_INVALID",
  SERVER_ERROR: "SERVER_ERROR",
  SESSION_EXPIRED: "SESSION_EXPIRED",
  LOADING: "LOADING",

  //
  SINGLE_FILE_SIZE_LIMIT: "SINGLE_FILE_SIZE_LIMIT",
  UNAUTHORIZED: "UNAUTHORIZED",
  UPLOAD_TIMEOUT: "UPLOAD_TIMEOUT",
  UNDEFINED: "UNDEFINED",
} as const;

export type ErrorType = (typeof ERROR)[keyof typeof ERROR];

export const ERROR_TEXT: Record<ErrorType, string> = {
  CATEGORIES_NOT_FOUND: "Kategorien nicht verfügbar.",
  CATEGORY_INVALID: "Die Kategorie konnte nicht hochgeladen werden.",
  CATEGORY_NOT_FOUND: "Kategorie nicht gefunden.",
  CHAT_INVALID: "Der Chat konnte nicht eröffnet werden.",
  DATAPROTECTION_NOT_READ:
    "Um dich registrieren zu können, musst du der Datenschutzerklärung zustimmen.",
  FETCH: "Netzwerkfehler.",
  LOADING: "Warten auf einen anderen Vorgang.",
  FILE_AMOUNT_LIMIT: `Zu viele Bilder. Maximal ${MAX_FILES_AMOUNT} erlaubt.`,
  FILE_DELETE:
    "Die Bilder konnten nicht gelöscht werden. Versuche es (später) erneut.",
  FILE_SIZE_LIMIT: `Die Bilder sind zu groß, um hier hochgeladen zu werden. Es sind maximal ${MAX_FILES_SIZE} MB pro Upload verfügbar.`,
  FILE_UPLOAD:
    "Die Bilder konnten nicht hochgeladen werden. Versuche es (später) erneut.",
  ITEM_INVALID:
    "Die Anzeige hatte einen Fehler und konnte nicht veröffentlicht werden.",
  ITEM_NOT_FOUND: "Anzeige nicht gefunden.",
  LOGIN_INVALID: "E-Mail oder Passwort inkorrekt.",
  NETWORK: "Verbindung zum Server fehlgeschlagen.",
  OTP_EXPIRED:
    "Der Code is abgelaufen oder falsch, ein neuer Code wurde gesendet.",
  PAYLOAD_MALFORMATTED:
    "Die Antwort vom Surfanzeigen konnte nicht verarbeitet werden.",
  REGISTER_INVALID:
    "Bitte überprüfe deine Angaben, vielleicht existiert dein Account?",
  SERVER_ERROR:
    "Die Daten konnten nicht verarbeitet werden. Versuche es erneut.",
  SESSION_EXPIRED: "Deine Session ist abgelaufen. ",
  //
  SINGLE_FILE_SIZE_LIMIT: `Bilder sind zu groß, die Datei darf nicht größer als ${MAX_FILE_SIZE} MB sein.`,
  UPLOAD_TIMEOUT: "Die Bilder brauchen zu lange zum Hochladen. ",
  UNAUTHORIZED: "Deine Anmeldung von früher ist nicht mehr gültig.",
  UNDEFINED: "Ein Fehler ist aufgetreten.",
};

export function isErrorType(value: unknown): value is ErrorType {
  return (
    typeof value === "string" &&
    Object.values(ERROR).includes(value as ErrorType)
  );
}

export function parseError(payload: unknown): ErrorType {
  if (isErrorType(payload)) {
    return payload; // valid
  }

  if (payload instanceof DOMException) {
    if (payload.name === "AbortError") {
      return ERROR.FETCH;
    }
  }

  if (payload instanceof TypeError) {
    return ERROR.NETWORK;
  }

  if (payload instanceof SyntaxError) {
    return ERROR.PAYLOAD_MALFORMATTED;
  }

  console.error(
    "Please report this error, it is not handled correctly: ",
    payload,
  );
  return ERROR.UNDEFINED;
}
